import { Helmet } from 'react-helmet-async';
import ExpenceManagementView from './components/ExpenceManagementView';
import {
  PageTitleWrapper,
  PageHeader,
  SimpleDialog,
  CustomForm,
  ButtonToggle,
  showErrorMessage,
  FormField
} from '../../shared/components/index';
import {
  Grid,
  Container,
  Box,
  Typography,
  Button,
  TextField,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { useEffect, useState, MouseEvent } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { findExpencesByTenantId } from './services/expenceManagement.service';
import * as userEvent from './services/expenceManagement.service';
import { selectUserState } from 'src/auth/login/services/userSlice';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useTranslation } from 'react-i18next';
import * as assetService from '../Asset/services/assetManagement.service';
import {
  I18N,
  LIST_VIEW,
  REGEX,
  ROLES,
  TENANT_ROLES
} from '../../shared/constants/constants';
import * as ROUTES from '../../shared/constants/routes';
import GridViewSharpIcon from '@mui/icons-material/GridViewSharp';
import TableRowsTwoToneIcon from '@mui/icons-material/TableRowsTwoTone';
import { VIEW_TYPE } from './utils/utils';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useFormik } from 'formik';
import AddExpenceModal from './components/AddExpenceModal';
import { Expence, PaymentType } from './models';
//  import ExpenceManagementView from './components/ExpenceManagementView';


const ExpenceManagement = () => {
  const [selectedTab, setSelectedTab] = useState<string | null>(
    LIST_VIEW.TABLE_VIEW
  );
  const [open, setOpen] = useState<boolean>(false);
  const [viewType, setViewType] = useState<string>(VIEW_TYPE.EXPENCE_MANAGEMENT);
  const [isAddModal, setIsAddModal] = useState<boolean>(true);
  const { t } = useTranslation(I18N.DEFAULT);
  const dispatch = useDispatch<any>();
  const [expenceList, setExpenceList] = useState<Expence[]>([]);
  const {
    expences,
    isOrgExpenceListUpdated,
    isError,
    errorMessage,
    userAssetsData,
    isExpenceAssetsListUpdated
  } = useSelector(userEvent.selectorExpenceManagementState);
  const { selectedOrganization, loginUserRole } = useSelector(selectUserState);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [breadcrumbsHeading, setBreadcrumbsHeading] = useState(t('expense.expence-management'));
  const [headerSubtitle, setHeaderSubtitle] = useState(`${t('expense.list-all-expence-management-label')} ${selectedOrganization.tenantName}`);
  const [selectedExpence, setSelectedExpence] = useState();
  const {
    tenantAssetList
  } = useSelector(assetService.selectorAssetState);
  const location = useLocation();
  const [params] = useSearchParams();
  const [assetList, setAssetList] = useState([]);

  useEffect(() => {
    dispatch(findExpencesByTenantId(selectedOrganization.id));
    dispatch(assetService.getAssetByTenantIdData({
      tenantId : selectedOrganization.id, 
      isExpenses: false
    }));
    const breadcrumb = [
      {
        name: t('organization'),
        route: `${ROUTES.ADMIN_LOGIN}${ROUTES.ORGANIZATION}`
      },
      {
        name: selectedOrganization.tenantName,
        route: ROUTES.USER_MANAGEMENT
      }
    ];
    setBreadcrumbs(breadcrumb);
  }, []);

  useEffect(() => {
    let list = [];
    setAssetList(list);
    if (tenantAssetList?.length > 0) {
      for (let index = 0, length = tenantAssetList.length; index < length; ++index) {
          const thisElement = {...tenantAssetList[index]};
          const name : string = thisElement.name;
          const code : string = thisElement.code ? thisElement.code : '';
          const size : string = thisElement.size ? `${code ? '|' : ''} ${thisElement.size}` : '';
          thisElement.label = `${code} ${size} | ${name}`;
          list.push(thisElement);
      }
    }
    setAssetList(list);
  }, [tenantAssetList]);

  useEffect(() => {
    if (isError) {
      dispatch(userEvent.setIsError(false));
      if (errorMessage !== '') {
        return showErrorMessage(errorMessage, {
          theme: 'colored',
          position: 'top-right',
          autoClose: 5000
        });
      }
    }
  }, [isError]);

  useEffect(() => {
    dispatch(findExpencesByTenantId(selectedOrganization.id));
    const breadcrumbsList = [
      {
        name: `organization`,
        route: `${ROUTES.ADMIN_LOGIN}${ROUTES.ORGANIZATION}`
      },
      {
        name: `${selectedOrganization.tenantName}`
      }
    ];
    setBreadcrumbs(breadcrumbsList);
  }, []);

  useEffect(() => {
    setExpenceList(expences);
  }, [expences]);

  useEffect(() => {
    setOpen(false);
    closeDialog();
    if (isOrgExpenceListUpdated) {
      dispatch(findExpencesByTenantId(selectedOrganization.id));
      dispatch(userEvent.setIsOrgExpenceListUpdated(false));
    }
  }, [isOrgExpenceListUpdated]);

  useEffect(() => {
    setOpen(false);
    closeDialog();
    if (isOrgExpenceListUpdated) {
      dispatch(findExpencesByTenantId(selectedOrganization.id));
      dispatch(userEvent.setIsOrgExpenceListUpdated(false));
    }
  }, [isOrgExpenceListUpdated]);

  const handleAddUserButtonClick = () => {
    setIsAddModal(true);
    setOpen(true);
  };

  const handleFilterUsers = (value: string) => {
    const filterExpenceData: Expence[] = expences.filter(function (item) {
      return item.email.toLowerCase().includes(value.toLowerCase());
    });
    setExpenceList(filterExpenceData);
  };

  const handleClose = (value) => {
    setOpen(false);
  };
  const closeDialog = () => {
    setOpen(false);
  };

  const onCancel = () => {
    closeDialog();
  };

  const handleEditIconClick = (row) => {
    setSelectedExpence(row);
    setIsAddModal(false);
    setOpen(true);
  };

  const onSubmit = (values: any) => {
    const expenceData: Expence = { ...values, tenantId: selectedOrganization.id };
    if (!isAddModal) {
      dispatch(
        userEvent.updateExpence(expenceData)
      );
    } else {
      dispatch(
        userEvent.addExpence(expenceData)
      );
    }
  };

  const handleViewOrientation = (
    _event: MouseEvent<HTMLElement>,
    newValue: string | null
  ) => {
    if (newValue !== null) {
      setSelectedTab(newValue);
    }
  };
  return (
    <>
      <Helmet>
        <title>BookingDLiteExpence</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader
          breadcrumbs={breadcrumbs}
          heading={breadcrumbsHeading}
          subHeading={headerSubtitle}
        >
          {viewType == VIEW_TYPE.EXPENCE_MANAGEMENT && (
            <Button
              size={'small'}
              sx={{ pt: 1, pb: 1 }}
              className="letter-spacing"
              variant={'contained'}
              startIcon={<AddTwoToneIcon fontSize="small" />}
              onClick={handleAddUserButtonClick}
            >
              {t('expense.add-expence')}
            </Button>
          )}
          <TextField
            size={'small'}
            id="outlined-search"
            label={t('expense.search-expence-label')}
            type="search"
            onChange={(e) => handleFilterUsers(e.target.value)}
          />
          {/* <ToggleButtonGroup
            value={selectedTab}
            exclusive
            onChange={handleViewOrientation}
            size={'small'}
          >
            <ToggleButton disableRipple value={LIST_VIEW.CARD_VIEW}>
              <GridViewSharpIcon />
            </ToggleButton>
            <ToggleButton disableRipple value={LIST_VIEW.TABLE_VIEW}>
              <TableRowsTwoToneIcon />
            </ToggleButton>
          </ToggleButtonGroup> */}
        </PageHeader>
      </PageTitleWrapper>

      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          {open ? <AddExpenceModal
            isAddModal={isAddModal}
            open={open}
            assets={assetList}
            onSubmit={onSubmit}
            handleClose={handleClose}
            editObject={selectedExpence}
          ></AddExpenceModal> :
            <Grid item xs={12}>
              <ExpenceManagementView
                handleEditIconClick={handleEditIconClick}
                inputExpenceData={expenceList}
                inputSelectedTab={selectedTab}
                viewType={viewType}
              />
            </Grid>}
        </Grid>
      </Container>
    </>
  );
};

export default ExpenceManagement;
